import { toast } from "react-toastify";
import { config, errToast } from "../../utils";
import { axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import { buildQuery, getTotalPages } from "../../helpers";
import {
    handleSessionData,
    handleSessionDetailData,
} from "../slice/sessionSlice";

export const fetchLiveSessions = (payload) => {
    return async (dispatch, getState) => {
        dispatch(handleSessionData({ sessions: { loading: true } }));
        const state = getState();
        const { sessions } = state.session;
        const isAuthenticated = state.auth.isAuthenticated;
        const axiosInstance = isAuthenticated ? axiosAuth : axiosUnauth;

        const type = payload.type ?? sessions.type;
        const dateFilter =
            payload.dateFilter !== undefined
                ? payload.dateFilter
                : sessions.dateFilter;

        const params = {
            page: payload.page ?? 1,
            page_size: sessions.page_size,
            type,
        };

        if (dateFilter) {
            params[type === "ended" ? "ended" : "started"] = dateFilter;
        }

        try {
            const response = await axiosInstance.post(
                "/api-session/live-session-listing/",
                params,
                config
            );

            if (response.status === 200 && response.data.error === 0) {
                const { data, total } = response.data.data;
                dispatch(
                    handleSessionData({
                        sessions: {
                            data,
                            page: params.page,
                            total,
                            totalPage: getTotalPages(total, sessions.page_size),
                            loading: false,
                            type,
                            dateFilter,
                        },
                    })
                );
            } else {
                toast.error(response.data.msg);
                dispatch(handleSessionData({ sessions: { loading: false } }));
            }

            return response.data;
        } catch (err) {
            errToast(err);
            dispatch(handleSessionData({ sessions: { loading: false } }));
        }
    };
};

export const fetchSessionDetail = (sessionId) => {
    return async (dispatch, getState) => {
        dispatch(handleSessionDetailData({ loading: true, data: null }));
        const state = getState();
        const isAuthenticated = state?.auth?.isAuthenticated;
        const user_id =
            state?.auth?.user?.user_id ?? state?.auth?.user?.id ?? "";
        const axiosInstance = isAuthenticated ? axiosAuth : axiosUnauth;
        try {
            const response = await axiosInstance.post(
                `/api-session/live-session-details/${sessionId}/`,
                {
                    // user_id,
                },
                config
            );
            if (response.status === 200 && response.data.error === 0) {
                dispatch(
                    handleSessionDetailData({
                        data: response.data.data.data,
                        loading: false,
                    })
                );
            } else {
                toast.error(response.data.msg);
                dispatch(handleSessionDetailData({ loading: false }));
            }
            return response.data;
        } catch (err) {
            errToast(err);
            dispatch(handleSessionDetailData({ loading: false }));
        }
    };
};
